module.exports = __webpack_public_path__ + "static/media/logowhite.a68d084b.png";